import {
  bulkChurnEntity,
  bulkEditEntity,
  bulkPulseUpdate,
  bulkUploadEntity,
  getBulkUploadHistory,
} from '../../routines';

const initialState = {
  bulkEditSubmitLoading: false,
  bulkEditSubmitResult: null,
  bulkEditSubmitError: null,
  bulkUploadHistory: {
    loading: false,
    data: [],
    error: null,
  },
};

const bulkEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case getBulkUploadHistory.TRIGGER: {
      return {
        ...state,
        bulkUploadHistory: {
          ...state.bulkUploadHistory,
          loading: true,
          error: null,
        },
      };
    }
    case getBulkUploadHistory.FAILURE: {
      return {
        ...state,
        bulkUploadHistory: {
          ...state.bulkUploadHistory,
          loading: false,
          error: action.payload.error,
        },
      };
    }
    case getBulkUploadHistory.SUCCESS: {
      return {
        ...state,
        bulkUploadHistory: {
          ...state.bulkUploadHistory,
          loading: false,
          data: action.payload.data,
        },
      };
    }
    case bulkUploadEntity.TRIGGER:
    case bulkChurnEntity.TRIGGER:
    case bulkPulseUpdate.TRIGGER:
    case bulkEditEntity.TRIGGER: {
      return {
        ...state,
        bulkEditSubmitLoading: true,
        bulkEditSubmitResult: null,
        bulkEditSubmitError: null,
      };
    }
    case bulkUploadEntity.SUCCESS:
    case bulkChurnEntity.SUCCESS:
    case bulkPulseUpdate.SUCCESS:
    case bulkEditEntity.SUCCESS: {
      return {
        ...state,
        bulkEditSubmitLoading: false,
        bulkEditSubmitResult: action.payload.data,
        bulkEditSubmitError: null,
      };
    }
    case bulkUploadEntity.FAILURE:
    case bulkChurnEntity.FAILURE:
    case bulkPulseUpdate.FAILURE:
    case bulkEditEntity.FAILURE: {
      return {
        ...state,
        bulkEditSubmitLoading: false,
        bulkEditSubmitResult: null,
        bulkEditSubmitError: action.payload.error,
      };
    }
    default:
      return state;
  }
};

export default bulkEditReducer;
